import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import './ReportPlay.css'
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import stopPng from '../Images/stop.png'
import playPng from "../Images/play.png"
import closePlay from "../Images/closePlay.png"

//import momentJalaali from 'moment-jalaali';
import distanceIcon from '../Images/distanceIcon.png'
import distanceAllIcon from '../Images/distanceAllIcon.png'
import speedIcon from '../Images/speedIcon.png'
import park from "../Images/parkinIcon.png"
import timePark from "../Images/timePark.png"
import timeEndIcon from '../Images/timeEndIcon.png'
import timeStartIcon from '../Images/timeStartIcon.png'
import arrowRight from '../Images/arrowRight.png'
import arrowLeft from '../Images/arrowLeft.png'

import TimePicker from "react-multi-date-picker/plugins/analog_time_picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import gregorian_fa from "react-date-object/locales/gregorian_fa";

import { MainContext } from "../store/mainContext";
import React, { useContext, useEffect, useState } from "react";
//import { setConstantValue } from 'typescript';

export default function ReportPlay({ doClose, onPlay, play
  , onSetSpeed, onShowParking, doPlay,doRestart  }) {

  const { defaultDevice, routePoint, setRoutePoint } = useContext(MainContext);
  useEffect(() => {
  }, []);



  useEffect(() => {
    if (play == "off") {
      setDistance(0);
    }
  }, [play]);

  const [distanceAll, setDistanceAll] = useState(0);
  const [distance, setDistance] = useState(0);
  const [showParking, setShowParking] = useState(true);
  const [speed, setSpeed] = useState(500);
  const [maxSpeed, setMaxSpeed] = useState(0)
  const [countPark, setCountPark] = useState(0)
  const [timeStop, setTimeStop] = useState(0)
  const [timeStart, setTimeStart] = useState("")
  const [timeEnd, setTimeEnd] = useState("")
  useEffect(() => {
    if (onPlay > 0 && onPlay < routePoint.length) {
      setDistance(routePoint[onPlay].distanceSum);
    }
  }, [onPlay]);


  useEffect(() => {
    onSetSpeed(speed)
  }, [speed]);

  useEffect(() => {
    onShowParking(showParking)
  }, [showParking]);

  useEffect(() => {
    if (!routePoint || routePoint.length <= 0) {
      setDistanceAll(0);
      setMaxSpeed(0);
      setCountPark(0)
      setTimeStop(0)
      return;
    }

    setMaxSpeed(Math.max(...routePoint.map(o => o.speed)));
    setDistanceAll(routePoint[routePoint.length - 1].distanceSum);
    setCountPark(routePoint.filter(o => o.stopTime != "0").length)
    setTimeStop(routePoint.reduce((accumulator, currentValue) => {
      return accumulator + parseInt(currentValue.stopTime)
    }, 0))
    setTimeStart(routePoint[0].time)
    setTimeEnd(routePoint[routePoint.length - 1].time)

  }, [routePoint]);



  const [isLoading, setIsLoading] = useState(false);
  const changeDate = async (mode, data) => {
    if (isLoading)
      return;

    setIsLoading(true);
    if (!data)
      data = valueDate;
    if (!(data.date instanceof DateObject) ||
      !(data.fromTime instanceof DateObject) ||
      !(data.tooTime instanceof DateObject)) {
      toast.error('داده ها جهت ارسال کامل نمی باشد', { theme: "colored" });
      return
    }

    await noronServices.reportDay({
      id: defaultDevice.id,
      date: data.date.format("YYYY/MM/DD"),
      fromTime: data.fromTime.format("HH:mm"),
      tooTime: data.tooTime.format("HH:mm"),
      mode: mode
    })
      .then(({ data }) => {
        setIsLoading(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setValueDate({
          ...valueDate, date: new DateObject({
            date: data.message,
            format: "YYYY/MM/DD",
            calendar: persian,
            locale: persian_fa,
          })
        });
        if (data.payload.length <= 0) {
          toast.error('داده ای یافت نشد', { theme: "colored" });
          return;
        }
        setRoutePoint(data.payload);
        //toast.dark(' ');         
      })
      .catch(err => {
        setIsLoading(false);
      });
  }


  let [valueDate, setValueDate] = useState(
    {
      date: new DateObject(),
      fromTime: new DateObject({
        date: new Date(),
        hour: 0,
        minute: 0,
        second: 0,
      }),
      tooTime: new DateObject({
        date: new Date(),
        hour: 23,
        minute: 59,
        second: 0,
      })
    })

  const [showAdvanceDate, setShowAdvanceDate] = useState(false)
  useEffect(() => {
    console.log('defaultDevice', defaultDevice);
    if (defaultDevice==null || !('from' in defaultDevice))
      return;
    setShowAdvanceDate(defaultDevice.dateMode == 1);
    const date = new DateObject({
      date: new Date(defaultDevice.from),//defaultDevice.from.format('jYYYY/jM/jD'),
      format: "YYYY/MM/DD",
      calendar: persian,
      locale: persian_fa,
    });
    //console.log('momentJalaali(distanceAllIcon)', date)
    setValueDate({ ...valueDate, date: date })
  }, [defaultDevice]);





  const CreateBox = ({ img, caption, value }) => {
    return (
      <div className='col-3 col-md-1 border rounded mx-2 bg-white p-2'>
        <div className='row'>
          <div className='col-auto pe-0'>
            <img src={img} style={{ width: "30px" }} />
          </div>
          <div className='col d-flex align-items-center justify-content-center ' style={{ fontSize: "8px" }}>
            {caption}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col text-center'>
            {value}
          </div>
        </div>
      </div>)
  }
  return (
    <>
      <div id="playRoute" className="row">
            <div className="col-auto  align-items-center d-flex colButton p-0">
              <button
                className="btn p-0"
                onClick={doPlay}>
                <span className='btnPlay'>{play == "play" ? "⏹️" : "▶️"} </span>
              </button>
              <button
                className="btn p-0"
                onClick={doRestart}>
                <span className='btnPlay'>🔁</span>
              </button>
            </div> 
            <div className="col align-items-center d-flex">
              <div className="row">
                <div className="col  align-items-center d-flex justify-content-center" id="speedColPlayBorad">
                  <input
                    type="radio"
                    checked={speed == 500}
                    onChange={(e) => setSpeed(500)}
                    className="radioSpeedPlayBoard" />
                  <span className="speedCaption">کم</span>

                  <input
                    type="radio"
                    checked={speed == 50}
                    onChange={(e) => setSpeed(50)}
                    className="radioSpeedPlayBoard" />
                  <span className="speedCaption">متوسط</span>

                  <input
                    type="radio"
                    checked={speed == 5}
                    onChange={(e) => setSpeed(5)}
                    className="radioSpeedPlayBoard" />
                  <span className="speedCaption">زیاد</span>
                </div>

                <div className="col  align-items-center d-flex justify-content-center">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={showParking}
                      onChange={(e) => setShowParking(p => !p)}
                      id="flexSwitchCheckDefault"
                    />
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">نمایش نقاط توقف</label>
                  </div>
                </div>

              </div>
            </div>
            <div className="col-auto  align-items-center d-flex  colButton p-0">
              <button
                className="btn  "
                onClick={doClose}>
                <img src={closePlay} className="iconPlayBoard" />
              </button>
            </div>
          </div>

      {showAdvanceDate &&
        <div className='row py-2'>
          <div className='col d-flex justify-content-center align-items-center'>
            <Link
              to="/"
              className="text-decoration-none border rounded me-2 p-1"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                changeDate(-1);
              }
              }
            >
              <img src={arrowRight} className='iconArrow' />
              <span className='  LabelTimePicker'>روز قبل</span>
              {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
            </Link>
            <DatePicker
              inputClass="form-controlTimePicker"
              disableDayPicker
              format="HH:mm"
              value={valueDate.fromTime}
              onChange={value => {
                console.log('fromTime change', value);
                setValueDate({ ...valueDate, fromTime: value });
                changeDate(0, { ...valueDate, fromTime: value });
              }}
              plugins={[<TimePicker hideSeconds />]}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
            // style={{width:"80px" }}
            />
            <DatePicker
              inputClass="form-controlDatePicker"
              containerStyle={{}}
              //style={{ width:"90px" }}
              //containerClassName="custom-container"
              format="YYYY/MM/DD"
              calendar={persian}//gregorian
              locale={persian_fa}//gregorian_en
              value={valueDate.date}
              onChange={value => {
                console.log('date', value);
                setValueDate({ ...valueDate, date: value })
                changeDate(0, { ...valueDate, date: value })
              }} />



            <DatePicker
              inputClass="form-controlTimePicker"
              disableDayPicker disabled={isLoading}
              format="HH:mm"
              value={valueDate.tooTime}
              onChange={value => {
                console.log('tooTime change', value);
                setValueDate({ ...valueDate, tooTime: value })
                changeDate(0, { ...valueDate, tooTime: value });
              }}
              plugins={[<TimePicker hideSeconds />]}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
            // style={{width:"80px" }}
            />
            <Link
              to="/"
              className="text-decoration-none border rounded ms-2 p-1"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                changeDate(1);
              }
              }
            >
              <img src={arrowLeft} className='iconArrow' />
              <span className=' LabelTimePicker'>روز بعد</span>
              {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
            </Link>
          </div>
        </div>
      }
      <div className='row bg1 py-2'>
        <div className='col p-0 '>
          <div className='d-flex overflow-x-scroll' style={{ overflowX: "auto" }}>
            <CreateBox
              img={distanceIcon}
              caption="مسافت طی شده"
              value={distance < 1000 ? `${Math.floor(distance)} متر` : `${(distance / 1000).toFixed(2)} کیلومتر`}
            />
            <CreateBox
              img={distanceAllIcon}
              caption="طول کل مســیر"
              value={distanceAll < 1000 ? `${Math.floor(distanceAll)} متر` : `${(distanceAll / 1000).toFixed(2)} کیلومتر`}
            />
            <CreateBox
              img={speedIcon}
              caption="بیشترین سرعت"
              value={maxSpeed}
            />
            <CreateBox
              img={park}
              caption="تعداد پارک"
              value={countPark}
            />
            <CreateBox
              img={timePark}
              caption="مدت زمان پارک "
              value={timeStop}
            />
            <CreateBox
              img={timeStartIcon}
              caption="ساعت شروع"
              value={timeStart}
            />
            <CreateBox
              img={timeEndIcon}
              caption="ساعت توقف"
              value={timeEnd}
            />
          </div>

        </div>
      </div>


    </>

  );

}
